import {Flex} from "antd";
import {useState} from "react";
import {ContactForm} from "./ContactForm";

interface Props {
    open: boolean;
    onClose: () => void;
    t: Record<string, any>;
    lang: string;
}

export const ContactModal = ({open, onClose, t, lang}: Props) => {
    const [success, setSuccess] = useState(false);

    if (!open) return null;

    const handleClose = () => {
        setSuccess(false);
        onClose();
    };

    const dir = lang === 'he' ? 'rtl' : 'ltr';

    return (
        <div className="modal-overlay" onClick={handleClose}>
            <div className="modal" onClick={(e) => e.stopPropagation()}>
                {!success ? (
                    <>
                        <Flex style={{marginBottom: 20}} justify={'space-between'} align={'center'} dir={dir}>
                            <h2 style={{margin: 0}}>{t.contact}</h2>
                            <div className="lang-btn" style={{width: 32, height: 32, padding: 8}} onClick={handleClose}>
                                <svg width="16" height="16" viewBox="0 0 24 24">
                                    <path
                                        d="M6 6L18 18M18 6L6 18"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        fill="none"
                                        strokeLinecap="round"
                                    />
                                </svg>
                            </div>
                        </Flex>
                        <ContactForm t={t} onSubmitSuccess={() => setSuccess(true)}/>
                    </>
                ) : (
                    <div className="success-state">
                        <Flex style={{marginBottom: 20}} justify={'space-between'} align={'center'} dir={dir}>
                            <h2 style={{margin: 0}}>{t.successTitle}</h2>
                            <div className="lang-btn" style={{width: 32, height: 32, padding: 8}} onClick={handleClose}>
                                <svg width="24" height="24" viewBox="0 0 24 24">
                                    <path
                                        d="M6 6L18 18M18 6L6 18"
                                        stroke="#000000"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                    />
                                </svg>
                            </div>
                        </Flex>
                        <p>{t.successDesc}</p>
                        <button className="button button-primary" onClick={handleClose}>OK</button>
                    </div>
                )}
            </div>
        </div>
    );
};
